
export const USER_SETTINGS_UPDATE_REQUEST = 'USER_SETTINGS_UPDATE_REQUEST';
export const USER_SETTINGS_UPDATE_SUCCESS = 'USER_SETTINGS_UPDATE_SUCCESS';
export const USER_SETTINGS_UPDATE_FAIL = 'USER_SETTINGS_UPDATE_FAIL';
